import { Link } from "react-router-dom";
import { Cake, Heart, Briefcase, PartyPopper, Users, TreePine, ArrowUpRight } from "lucide-react";

const OCCASIONS = [
  {
    slug: "Birthdays",
    label: "Birthday Parties",
    sub: "Pool · Decor · Cake",
    icon: Cake,
    image: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&q=85&w=900",
    accent: "#F4A930",
  },
  {
    slug: "Weddings",
    label: "Weddings",
    sub: "Mandap · Lawn · Suites",
    icon: Heart,
    image: "https://images.unsplash.com/photo-1769812344096-8993973bd233?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    accent: "#7CB342",
  },
  {
    slug: "Corporate Outings",
    label: "Corporate Outings",
    sub: "Offsites · Workshops",
    icon: Briefcase,
    image: "https://images.unsplash.com/photo-1515169067868-5387ec356754?auto=format&fit=crop&q=85&w=900",
    accent: "#1F5A43",
  },
  {
    slug: "Bachelor Parties",
    label: "Bachelor Nights",
    sub: "Pool · Bar · DJ",
    icon: PartyPopper,
    image: "https://images.pexels.com/photos/11185925/pexels-photo-11185925.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
    accent: "#F4A930",
  },
  {
    slug: "Family Events",
    label: "Family Gatherings",
    sub: "Reunions · Pujas",
    icon: Users,
    image: "https://images.unsplash.com/photo-1609220136736-443140cffec6?auto=format&fit=crop&q=85&w=900",
    accent: "#7CB342",
  },
  {
    slug: "Weekend Getaways",
    label: "Weekend Retreats",
    sub: "Forest · Pool · Bonfire",
    icon: TreePine,
    image: "https://images.pexels.com/photos/33575697/pexels-photo-33575697.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
    accent: "#1F5A43",
  },
];

export default function OccasionStrip() {
  return (
    <section className="bg-[#FAFAF8] py-20 md:py-24" data-testid="occasion-strip-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-end justify-between flex-wrap gap-3 mb-10">
          <div>
            <div className="kicker mb-3">Browse by occasion</div>
            <h2 className="font-sora text-3xl md:text-4xl font-semibold tracking-tight text-[#0E2E24] leading-tight">
              What are you celebrating?
            </h2>
            <p className="mt-3 max-w-xl text-[#5B6B63]">
              Tell us the moment — we'll match it with a property, a vendor list and a quote within 30 minutes.
            </p>
          </div>
          <Link to="/stays" className="font-sora text-sm font-medium text-[#1F5A43] hover:text-[#0E2E24] flex items-center gap-1.5" data-testid="occasion-strip-see-all">
            See all categories <ArrowUpRight size={15} />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {OCCASIONS.map((o) => (
            <Link
              key={o.slug}
              to={`/stays?occasion=${encodeURIComponent(o.slug)}`}
              className="group relative rounded-2xl overflow-hidden aspect-[3/4] hover-lift"
              data-testid={`occasion-chip-${o.slug.toLowerCase().replace(/\s/g, '-')}`}
            >
              <img src={o.image} alt={o.label} className="img-cover zoom-img" loading="lazy" />
              <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(14,46,36,0.05)_30%,rgba(14,46,36,0.85)_100%)]" />
              {/* Top icon chip */}
              <div className="absolute top-3 left-3 h-9 w-9 rounded-xl flex items-center justify-center" style={{ backgroundColor: o.accent }}>
                <o.icon size={16} className="text-[#0E2E24]" strokeWidth={2.4} />
              </div>
              {/* Bottom copy */}
              <div className="absolute bottom-0 left-0 right-0 p-4 text-[#FAFAF8]">
                <div className="font-sora text-base md:text-lg font-semibold leading-tight">{o.label}</div>
                <div className="mt-0.5 text-[11px] tracking-wide font-sora text-[#FAFAF8]/85">{o.sub}</div>
              </div>
              {/* Hover arrow */}
              <div className="absolute top-3 right-3 h-9 w-9 rounded-full bg-[#FAFAF8]/95 flex items-center justify-center opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all">
                <ArrowUpRight size={15} className="text-[#0E2E24]" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
